/**
 * AI workflow 信号桥 —— 业务组件与 AI workflow 之间的真实结果传递
 *
 * 背景：awaitAction 的语义是"用户点击即 step 完成"，不感知点击后同步校验
 * 和异步接口的结果，导致"校验没过/接口失败但卡片显示完成"的假成功。
 * 业务组件在决策点（校验失败 / 接口成功 / 接口失败）record，
 * workflow step handle 里 wait，结果如实回传后端。
 *
 * 会话语义：clear() 开启新一轮等待并丢弃残留；record 先写先得（first-write-wins），
 * 同一轮内后续 record 忽略 —— 避免后续事件把首个真实结果覆盖掉。
 */
export function createSignal() {
  let result = null
  let waiter = null

  return {
    clear() {
      result = null
      waiter = null
    },

    /**
     * @param {{ success: boolean, error?: string }} r
     */
    record(r) {
      if (result) return
      result = r
      if (waiter) {
        const resolveWaiter = waiter
        waiter = null
        resolveWaiter(r)
      }
    },

    /**
     * 已有结果立即返回；否则挂起等待，超时 reject
     * @param {number} timeout - 毫秒
     * @param {string} timeoutMessage - 超时错误文案（回传 workflow）
     * @returns {Promise<{ success: boolean, error?: string }>}
     */
    wait(timeout, timeoutMessage) {
      if (result) {
        return Promise.resolve(result)
      }

      return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
          waiter = null
          reject(new Error(timeoutMessage))
        }, timeout)
        waiter = (r) => {
          clearTimeout(timer)
          resolve(r)
        }
      })
    }
  }
}

// 价格/库存抽屉（drawerV2）保存结果：batch_update_calendar_setting_v2
export const priceInvSaveSignal = createSignal()
